/**
 * @generated SignedSource<<e408094aef730c8826235cb6a31de8b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type SubscriptionStatus = "ACTIVE" | "CANCELLED" | "PAST_DUE" | "PENDING" | "%future added value";
export type SubscribeToPlanInput = {
  autoChargeExcess?: boolean | null;
  cpf?: string | null;
  creditCard?: CreditCardInput | null;
  creditCardHolderInfo?: CreditCardHolderInfoInput | null;
  plan: PlanSlug;
  promotionalCode?: string | null;
  savedCardId?: string | null;
};
export type CreditCardInput = {
  ccv: string;
  expiryMonth: string;
  expiryYear: string;
  holderName: string;
  number: string;
};
export type CreditCardHolderInfoInput = {
  addressNumber: string;
  cpfCnpj: string;
  email: string;
  mobilePhone?: string | null;
  name: string;
  phone?: string | null;
  postalCode: string;
};
export type SubscribeToPlanMutation$variables = {
  input: SubscribeToPlanInput;
};
export type SubscribeToPlanMutation$data = {
  readonly SubscribeToPlan: {
    readonly brCode: string | null;
    readonly chargeCorrelationID: string | null;
    readonly error: string | null;
    readonly paymentLinkUrl: string | null;
    readonly subscription: {
      readonly dayGenerateCharge: number;
      readonly id: string;
      readonly plan: PlanSlug;
      readonly status: SubscriptionStatus;
      readonly valueCents: number;
    } | null;
  };
};
export type SubscribeToPlanMutation = {
  response: SubscribeToPlanMutation$data;
  variables: SubscribeToPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubscribeToPlanPayload",
    "kind": "LinkedField",
    "name": "SubscribeToPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RestaurantSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueCents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayGenerateCharge",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentLinkUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "brCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargeCorrelationID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscribeToPlanMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscribeToPlanMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4de369725c9079d766f2e7465cf3948e",
    "id": null,
    "metadata": {},
    "name": "SubscribeToPlanMutation",
    "operationKind": "mutation",
    "text": "mutation SubscribeToPlanMutation(\n  $input: SubscribeToPlanInput!\n) {\n  SubscribeToPlan(input: $input) {\n    subscription {\n      id\n      plan\n      status\n      valueCents\n      dayGenerateCharge\n    }\n    paymentLinkUrl\n    brCode\n    chargeCorrelationID\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5dcf2de44ad8d9a2eb661fb7e1c07f4d";

export default node;
